{
  "forms": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "add": "Ajouter",
    "update": "Mettre à jour",
    "edit": "Modifier",
    "delete": "Supprimer",
    "confirm": "Confirmer",
    "submit": "Soumettre",
    "create": "Créer",
    "search": "Rechercher",
    "search_placeholder": "Rechercher...",
    "select": "Sélectionner",
    "clear": "Effacer",
    "reset": "Réinitialiser",
    "apply": "Appliquer"
  },
  "nav": {
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "close": "Fermer",
    "open": "Ouvrir",
    "refresh": "Actualiser"
  },
  "status": {
    "loading": "Chargement...",
    "saving": "Enregistrement...",
    "deleting": "Suppression...",
    "updating": "Mise à jour...",
    "processing": "Traitement...",
    "success": "Succès",
    "error": "Erreur",
    "warning": "Avertissement",
    "info": "Info",
    "not_found": "Introuvable"
  },
  "actions": {
    "view": "Voir",
    "download": "Télécharger",
    "upload": "Téléverser",
    "import": "Importer",
    "export": "Exporter",
    "share": "Partager",
    "archive": "Archiver",
    "filters": {
      "title": "Filtres",
      "clear_filter": "Effacer le filtre",
      "more_filters": "Plus de filtres",
      "add_filter": "Ajouter un filtre",
      "is": "est",
      "one_of": "un de",
      "and": "et"
    },
    "restore": "Restaurer",
    "duplicate": "Dupliquer",
    "rename": "Renommer"
  },
  "confirmation": {
    "are_you_sure": "Êtes-vous sûr ?",
    "cannot_be_undone": "Cette action ne peut pas être annulée.",
    "confirm_delete": "Êtes-vous sûr de vouloir supprimer ceci ?",
    "confirm_archive": "Êtes-vous sûr de vouloir archiver ceci ?",
    "click_confirm": "Cliquez sur confirmer pour continuer"
  },
  "errors": {
    "context_provider_required": "useZIndex doit être utilisé dans un ZIndexProvider"
  }
}
